import React from 'react'

function Web() {
  return (
    <div>Web</div>
  )
}

export default Web